/**
 * @module ui/element-is-visible
 */

/**
 * @method io
 * @description A shorthand function for creating a new IntersectionObserver with configuration options
 * @param {HTMLElement} targetEl - the target element you wish to observe
 * @param {Function} callback - the callback function that the IntersectionObserver will execute
 * @param {Object} options - the configuration options to be passed to the IntersectionObserver
 * @returns {IntersectionObserver}
 */
export function io(targetEl, callback, options) {
  if (!targetEl) {
    console.error(`io error: target element "${targetEl}" cannot be observed.`);
    return;
  }
  const config = Object.assign({
    root: null,
    rootMargin: "0px",
    threshold: 0.5
  }, options);
  const io = new IntersectionObserver(callback, config);
  io.observe(targetEl);
  return io;
}

/**
 * @method isVisible
 * @param {HTMLElement} el - the element to check if it's visible in the UI
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
 * @returns {Boolean} true if visible
 */
export function isVisible(el) {
  return el && window.getComputedStyle(el).display !== "none";
}

/**
 * @method isHidden
 * @param {HTMLElement} el - the element to check if it's hidden in the UI
 * @returns {Boolean} true if hidden
 */
export function isHidden(el) {
  return !isVisible(el);
}
